import { cn } from "@gymflow/helpers";
import { Field, FieldProps, FormikProps } from "formik";

import {
  UsersSearchInput,
  UsersSearchInputOptionsType,
  UsersSearchInputProps,
} from "../../../base";
import { ErrorMessage } from "../../../ErrorMessage";
import { Path } from "../../types";

type FormUsersSearchInputProps<T> = {
  name: Path<T>;
} & Omit<UsersSearchInputProps, "value" | "onChange">;

/***
 * @deprecated please do not use this component as reference to create similar ones, check out `FormSelectLeadSource` instead
 */
export const FormSelectUsers = <T,>({
  name,
  className,
  ...props
}: FormUsersSearchInputProps<T>) => (
  <Field name={name}>
    {({
      field,
      form: { setFieldValue },
      meta: { touched, error },
    }: FieldProps<UsersSearchInputOptionsType, FormikProps<T>>) => {
      const isError = touched && error;
      return (
        <div className="flex flex-col gap-1.5">
          <UsersSearchInput
            {...props}
            value={field.value}
            onChange={(selected: UsersSearchInputOptionsType) =>
              setFieldValue(String(name), selected)
            }
            className={cn(
              className,
              isError && "outline-error-300 border-error-200",
            )}
          />
          {isError && <ErrorMessage text={error} />}
        </div>
      );
    }}
  </Field>
);
